// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3F0is","actionsCol":"EnrolledClinics_actionsCol__1SUAk"};